(function () {
    'use strict';

    angular
        .module('app')
        .controller('DeleteDocumentTemplateDialog', DeleteDocumentTemplateDialog);

    DeleteDocumentTemplateDialog.$inject = ['DocumentTemplatesService', 'DialogInstance', 'documentTemplateIds'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog prompting the user for confirmation they wish to delete a document template.
     * 
     */
    function DeleteDocumentTemplateDialog(DocumentTemplatesService, DialogInstance, documentTemplateIds) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = true;
        vm.documentTemplateCount = documentTemplateIds.length;
        vm.documentTemplateUsages = [];
        vm.ok = ok;
        vm.cancel = cancel;
        Object.defineProperty(vm, 'confirmMessage', {
            get: function () {
                return documentTemplateIds.length > 1 ? ('Delete the ' + documentTemplateIds.length + ' selected Document Templates?') : 'Delete the Document Template?';
            }
        });

        activate();

        function activate() {
            DocumentTemplatesService.getUsage(documentTemplateIds)
                .then(getUsageOk, getUsageError);

            function getUsageOk(result) {
                vm.documentTemplateUsages = result;
                vm.loading = false;
            }

            function getUsageError(response) {
                if (response.status === 404) {
                    vm.documentTemplateNotFound = true;
                }

                vm.error = true;
                vm.loading = false;
            }
        }

        function ok() {
            if (vm.documentTemplateNotFound) {
                DialogInstance.cancel();
            }

            DialogInstance.ok();
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
